export const PET_STATUS = {
    healthy: {
      value: 'healthy',
      label: 'Saludable',
      className: 'bg-green-200 text-green-800'
    },
    sick: {
      value: 'sick',
      label: 'Enfermo',
      className: 'bg-red-200 text-red-800'
    },
    recovering: {
      value: 'recovering',
      label: 'En recuperación',
      className: 'bg-yellow-200 text-yellow-800'
    }
    ,
    adopt: {
      value: 'adopt',
      label: 'adoptado',
      className: 'bg-green-300 text-yellow-850'
    },
    unavailable: {
        value: 'unavailable',
        label: 'No disponible',
        className: 'bg-gray-300 text-gray-800'
      }
  
  }

  ;

  export const PET_TYPES = {
    dog: {
      value: 'dog',
      label: 'Perro',
      icon: '🐕'  // opcional
    },
    cat: {
      value: 'cat',
      label: 'Gato',
      icon: '🐱'  // opcional
    }
  };


  export const PET_SIZES = {
    small: {
      value: 'small',
      label: 'Pequeño'
    },
    medium: {
      value: 'medium',
      label: 'Mediano'
    },
    large: {
      value: 'large',
      label: 'Grande'
    }
  };

export const GOOGLE_SHEET_LINK = 'https://forms.gle/j3iobkYuXUge7uSRA';
